import React, { useState } from "react";
import { motion } from "framer-motion";
import "./BlogBanner.scss";
import { Link } from "react-router-dom";

function SideBanner() {
  const [Email, setEmail] = useState("");
  return (
    <motion.div
      initial={{ x: 150, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true, amount: 0.4 }}
      className="side_banner_con"
    >
      <div className="side_banner_con_top">
        <h4>See Leapon in Action!</h4>
        <p>Wondering how Leapon can transform your networking?</p>
        <Link to="/get-demo#demo-booking" className="cta-btn">
          Book a Demo
        </Link>
      </div>

      <div className="side_banner_con_top side_banner_con_bottom">
        <h4>More Than A Business Card</h4>
        <p>Instant contact sharing, follow-ups, and contact management.</p>
        <input
          value={Email}
          type="text"
          placeholder="Enter your email address"
          onChange={(e) => setEmail(e.target.value)}
        />
        <Link
          to={
            Email
              ? "https://leapon.me/signup#email=" + Email
              : "https://leapon.me/signup/"
          }
          className="cta-btn"
          target="_blank"
        >
          Try Leapon
        </Link>
      </div>
    </motion.div>
  );
}

export default SideBanner;
